import view from '@/mixins/view'

export default {
  name: 'tpl-default',
  mixins: [view],
  data () {
    return {
      page: null
    }
  },
  created () {
    this.getPage().then(() => {
      if (!this.page) this.$router.push({ name: 'not-found' })
      this.ready = true
    })
  },
  methods: {
    fetchData: async function (store, params) {
      const isPage = params.post_type === 'page'
      return Promise.all([
        store.getters.get(params.post_type, params.post_id ? params.post_id : params.slug, params.post_id === undefined)
      ]).then(([page]) => {
        return { page }
      })
    },
    getPage: async function () {
      await this.fetchData(this.$store, Object.assign({}, this.$attrs, this.$route.params)).then(({ page }) => {
        this.page = page
      })
    }
  }
}
